const listAttributes = [
  'tutorialId',
  'startDatetime',
  'course',
  'duration',
  'host',
  'description',
  'joinLink',
  'capacity',
  'attendees',
  'linkedTutorials',
] as const;

const getAttributes = [...listAttributes] as const;

export const teacherUpdateAttributes = ['description', 'joinLink'] as const;

export const adminUpdateAttributes = [
  ...teacherUpdateAttributes,
  'host',
  'capacity',
  'attendees',
] as const;

export const TutorialAttributes = {
  List: listAttributes,
  Get: getAttributes,
  TeacherUpdate: teacherUpdateAttributes,
  AdminUpdate: adminUpdateAttributes,
};
